import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Divider, Stack, useMediaQuery } from "@mui/material";
import ButtonUX from "../../components/UI/Button/ButtonUX";
import { useLocation } from "react-router-dom";
import logo from "../../residenzaStoricaAssets/1811white.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function Navbar({
  isFooter,
  isRooms,
  isModal,
  isAdmin,
}: {
  isFooter?: boolean;
  isRooms?: boolean;
  isModal?: boolean;
  isAdmin?: boolean;
}) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigationLinks = [
    {
      text: "Home",
      link: "/",
    },
    {
      text: "Rooms",
      link: isMobile ? "/explorerooms" : "/rooms",
    },
  ];

  const rightLinks = [
    {
      text: "Location",
      link: "/location",
    },
    {
      text: "Raggiungici",
      link: "/location",
    },
  ];
  const page = "Booking";
  const currentPageAnchorPoints = navigationLinks.map((link) => link.text);
  const currentRightLinks = rightLinks.map((link) => link.text);
  const location = useLocation();
  const isNotHome = location.pathname !== "/";
  return (
    <AppBar
      style={{
        position: isFooter || isModal ? "relative" : "absolute",
        backgroundColor: isAdmin
          ? "#3c3131"
          : isFooter || isRooms || isModal
          ? "transparent"
          : "rgba(170, 170, 170, 0.152)", // Sfondo semi-trasparente
        width: "100%",
        display: "flex",
        backdropFilter: "blur(1.5px)",
        boxShadow: "none",
        padding: isNotHome && !isFooter ? "15px 0" : undefined,
        zIndex: 2,
      }}
    >
      <Stack
        sx={{
          width: "100%",
          height: isModal ? "50vh" : "100px",
          display: "flex",
          marginTop: isModal ? 7 : undefined,
          alignItems: isFooter ? "start" : "center",
          justifyContent: isModal || isMobile ? "center" : "space-between",
        }}
        direction="row"
        spacing={isFooter || isModal ? 0 : 3}
      >
        <Box
          width={"15%"}
          sx={{
            display: isModal || isFooter ? "none" : "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box position="absolute" top="0" left="50px" zIndex={9999}>
            <LanguageSwitcher />
          </Box>
        </Box>
        <Stack
          height={isModal ? "100%" : undefined}
          display={isRooms ? "none" : "flex"}
          direction={isFooter || isModal ? "column" : "row"}
          justifyContent={"space-between"}
          alignItems={isFooter && !isMobile ? "flex-start" : "center"}
        >
          {currentPageAnchorPoints.map((text, index) => {
            return (
              <div key={index}>
                {" "}
                <ButtonUX
                  isModal={isModal}
                  key={index}
                  text={text}
                  isFooter={isFooter}
                  hasBorder={false}
                  hasIcon={false}
                  padding={isFooter ? "8px 0" : undefined}
                />
                {isModal && (
                  <Divider
                    style={{
                      backgroundColor: "white",
                      opacity: 0.2,
                      width: "80vw",
                    }}
                  />
                )}
              </div>
            );
          })}
          {isNotHome && !isFooter ? (
            <img src={logo} alt="logo" style={{ width: "120px" }} /> // Log
          ) : (
            <ButtonUX
              isModal={isModal}
              text={"Contact"}
              isFooter={isFooter}
              hasBorder={false}
              hasIcon={false}
              padding={isFooter ? "8px 0" : undefined}
            />
          )}
          {currentRightLinks.map((text, index) => {
            return (
              <div key={index}>
                {" "}
                <ButtonUX
                  isModal={isModal}
                  key={index}
                  text={text}
                  isFooter={isFooter}
                  hasBorder={false}
                  hasIcon={false}
                  padding={isFooter ? "8px 0" : undefined}
                />
                {isModal && (
                  <Divider
                    style={{
                      backgroundColor: "white",
                      opacity: 0.2,
                      width: "80vw",
                    }}
                  />
                )}
              </div>
            );
          })}
        </Stack>
        <Box
          display={isFooter || isRooms || isModal ? "none" : "block"}
          width={"15%"}
        >
          <ButtonUX hasBorder padding="5px 15px" text={page} hasIcon isMain />
        </Box>
      </Stack>
    </AppBar>
  );
}
export default Navbar;
